import {TableCell, tableCellClasses, TableRow} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledTableRow = styled(TableRow)(({theme}) => ({
    background: 'transparent',
    borderTopColor: '#AAAAAA'
}));


export const StyledTableCell = styled
(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        color: '#100f0f'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14
    },
    whitespace: "wrap",
    textOverflow: "ellipsis"
}));